import { makeAutoObservable } from "mobx";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { acceptPatientFromOther, getPagePatient, notAcceptPatientFromOther } from "../Patient/Services/PatientService";

const searchObjectInitialValue = {
  fromDateTransfer: new Date(new Date().getFullYear(), 0, 1),
  toDateTransfer: new Date(),
  fromAge: 10,
  toAge: 100,
  statusOtherSystemTransfer: 1,
  // typeOfPatient: -2,
  isOtherSystemTransfer:true,
  orgSendOtherSystemTransfer: 1
};

export default class PatientFromOtherStore {
  searchObject = {...searchObjectInitialValue};
  patientList = [];
  selectedPatient = null;
  selectedPatientList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  keyword = "";
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  shouldOpenConfirmationDialog = false;
  shouldOpenConfirmationDeleteListDialog = false;


  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  handleSetSearchObject = (obj) => {
    this.searchObject = { ...searchObjectInitialValue, pageIndex: this.page, pageSize: this.rowsPerPage, ...obj }
  }

  updatePageData = (item) => {
    if(item){
      this.handleSetSearchObject(item);
    }
    this.search();
  };

  search = async () => {
    this.loadingInitial = true;
    try {
      let res = await getPagePatient({
        ...this.searchObject, 
        pageIndex: this.page, 
        pageSize: this.rowsPerPage,
      });
      this.patientList = res.data?.patients?.content;
      this.totalElements = res.data?.patients?.totalElements;
      this.totalPages = res.data?.patients?.totalPages;

      this.setLoadingInitial(false);
    } catch (error) {
      toast.warning("Có lỗi xảy ra, vui lòng thử lại!")
      console.log(error);
      this.setLoadingInitial(false);
    }
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  refusePatientFromOther = async (patient) => {
    await notAcceptPatientFromOther(patient).then(({data}) => {
      toast.success("Đã từ chối bệnh nhân!");
      this.updatePageData();
    })
    .catch((err) => {
      console.error(err);
      toast.error("Có lỗi xảy ra, vui lòng thử lại!")
    })
  }

  acceptPatientFromOther = async (patient) => {
    await acceptPatientFromOther(patient).then(({data}) => {
      switch (data?.code) {
        case "-1": {
          toast.error("Không thể tiếp nhận bệnh nhân vì bệnh nhân chưa có sổ khám nào.")
          break;
        }
        
        default: {
          toast.success("Đã tiếp nhận bệnh nhân!");
          break;
        }
      }
      
      this.updatePageData();
    })
    .catch((err) => {
      console.error(err);
      toast.error("Có lỗi xảy ra, vui lòng thử lại!")
    })
  }

}
